<template>
    <v-app id="inspire">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-12">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>钉钉管理后台</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>
                                <v-form>
                                    <v-text-field :rules="[rules.required]" v-model="ruleForm.username" prepend-icon="person" name="login" label="Login" type="text"></v-text-field>
                                    <v-text-field :rules="[rules.required]" v-model="ruleForm.password" id="password" prepend-icon="lock" name="password" label="Password" type="password"></v-text-field>
                                    <!--<p style="font-size:12px;line-height:30px;color:#999;padding-left: 33px;">使用问题联系全勇男 电话18777777105 微信同步。</p>-->
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="submitForm()">Login</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
	export default {
		data: () => ({

			ruleForm: {
				username: '',
				password: ''
			},
			rules: {
				required: value => !!value || 'Required.',
				counter: value => value.length <= 20 || 'Max 20 characters',
				email: value => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || 'Invalid e-mail.'
				}
			}
		}),
		methods: {
			submitForm() {

				let data = new FormData()
				data.append('username', this.ruleForm.username)
				data.append('password', this.ruleForm.password)
				this.$axios.post('http://pape.paquapp.com/login/', data).then((response) => {
                        if (response){
	                        localStorage.setItem('user', JSON.stringify(response));
	                        this.$alert('success', '欢迎');
	                        this.$router.push({
		                        name: 'AnnualReview'
	                        })
                        }

					}
				)
			}
		}
	}
</script>